module.exports = __webpack_public_path__ + "assets/img/31_375_big.b1288bae.jpg";